import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    ValidateAddress1,
    ValidateAddress2,
    ValidateCity,
    ValidateCompanyName,
    ValidateFirstName,
    ValidateLastName,
    ValidatePostalCode,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import translate from "@insite/client-framework/Translate";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";

const validCharacter = /^[a-zA-Z\u00C0-\u017F\s\d-]+$/;
const validPostalCode = new RegExp(/^[a-z][0-9][a-z][ ]?[0-9][a-z][0-9]$/, "i");
const isValidPostalCode = (value: string) => validPostalCode.test(value);
const isValidCharacter = (value: string) => validCharacter.test(value);
const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

replaceInChain(chain, ValidateFirstName, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { firstName } = props.parameter.address;
    if (
        addressFieldDisplayCollection.firstName?.isVisible &&
        validationRules.firstName?.isRequired &&
        isEmpty(firstName)
    ) {
        props.addressErrors.firstName = getRequiredErrorMessage(addressFieldDisplayCollection.firstName);
        /* Store Custom Code - Start */
    } else if (!isEmpty(firstName) && !isValidCharacter(firstName)) {
        props.addressErrors.firstName = translate("special_character_error");
        /* Store Custom Code - End */
    }
});
replaceInChain(chain, ValidateLastName, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { lastName } = props.parameter.address;
    if (
        addressFieldDisplayCollection.lastName?.isVisible &&
        validationRules.lastName?.isRequired &&
        isEmpty(lastName)
    ) {
        props.addressErrors.lastName = getRequiredErrorMessage(addressFieldDisplayCollection.lastName);
        /* Store Custom Code - Start */
    } else if (!isEmpty(lastName) && !isValidCharacter(lastName)) {
        props.addressErrors.lastName = translate("special_character_error");
        /* Store Custom Code - End */
    }
});

replaceInChain(chain, ValidateCompanyName, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { companyName } = props.parameter.address;
    if (
        addressFieldDisplayCollection.companyName?.isVisible &&
        validationRules.companyName?.isRequired &&
        isEmpty(companyName)
    ) {
        props.addressErrors.companyName = getRequiredErrorMessage(addressFieldDisplayCollection.companyName);
        /* Store Custom Code - Start */
    } else if (!isEmpty(companyName) && !isValidCharacter(companyName)) {
        props.addressErrors.companyName = translate("special_character_error");
        /* Store Custom Code - End */
    }
});

replaceInChain(chain, ValidateAddress1, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { address1 } = props.parameter.address;
    if (
        addressFieldDisplayCollection.address1?.isVisible &&
        validationRules.address1?.isRequired &&
        isEmpty(address1)
    ) {
        props.addressErrors.address1 = getRequiredErrorMessage(addressFieldDisplayCollection.address1);
        /* Store Custom Code - Start */
    } else if (!isEmpty(address1) && !isValidCharacter(address1)) {
        props.addressErrors.address1 = translate("special_character_error");
        /* Store Custom Code - End */
    }
});

replaceInChain(chain, ValidateAddress2, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { address2 } = props.parameter.address;
    if (
        addressFieldDisplayCollection.address2?.isVisible &&
        validationRules.address2?.isRequired &&
        isEmpty(address2)
    ) {
        props.addressErrors.address2 = getRequiredErrorMessage(addressFieldDisplayCollection.address2);
        /* Store Custom Code - Start */
    } else if (!isEmpty(address2) && !isValidCharacter(address2)) {
        props.addressErrors.address2 = translate("special_character_error");
        /* Store Custom Code - End */
    }
});

replaceInChain(chain, ValidateCity, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { city } = props.parameter.address;
    if (addressFieldDisplayCollection.city?.isVisible && validationRules.city?.isRequired && isEmpty(city)) {
        props.addressErrors.city = getRequiredErrorMessage(addressFieldDisplayCollection.city);
        /* Store Custom Code - Start */
    } else if (!isEmpty(city) && !isValidCharacter(city)) {
        props.addressErrors.city = translate("special_character_error");
        /* Store Custom Code - End */
    }
});

replaceInChain(chain, ValidatePostalCode, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { postalCode } = props.parameter.address;

    if (
        addressFieldDisplayCollection.postalCode?.isVisible &&
        validationRules.postalCode?.isRequired &&
        isEmpty(postalCode)
    ) {
        props.addressErrors.postalCode = getRequiredErrorMessage(addressFieldDisplayCollection.postalCode);
        /* Store Custom Code - Start */
    } else if (!isEmpty(postalCode) && !isValidPostalCode(postalCode)) {
        props.addressErrors.postalCode = translate("postal_code_error");
        /* Store Custom Code - End */
    }
});
